import { render, staticRenderFns } from "./UiGameHistoryGame.vue?vue&type=template&id=1b9efd02&scoped=true&"
import script from "./UiGameHistoryGame.vue?vue&type=script&lang=js&"
export * from "./UiGameHistoryGame.vue?vue&type=script&lang=js&"
import style0 from "./UiGameHistoryGame.vue?vue&type=style&index=0&id=1b9efd02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9efd02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b9efd02')) {
      api.createRecord('1b9efd02', component.options)
    } else {
      api.reload('1b9efd02', component.options)
    }
    module.hot.accept("./UiGameHistoryGame.vue?vue&type=template&id=1b9efd02&scoped=true&", function () {
      api.rerender('1b9efd02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/wheel/components/UiGameHistoryGame.vue"
export default component.exports